import React from "react";
import ClaimSCN from "../components/ClaimSCN";
import Donut from "../components/charts/Donut";
import CountUp from "../components/common/CountUp";
import SectionHeader from "../components/common/SectionHeader";
import { bnToNumber, fmtScn } from "../utils/format";

export default function ScnPage({ data, refresh, goTab }) {
  if (!data.registered) {
    return (
      <div className="card center fade-up" style={{ marginTop: 24 }}>
        <h2 className="card-title">SCN locked</h2>
        <p className="muted">Activate your node to start earning SCN.</p>
        <button className="btn mt-4" onClick={() => goTab("home")}>Go to Home</button>
      </div>
    );
  }

  const claimable = bnToNumber(data.scnStats.claimable);
  const wallet = bnToNumber(data.scnBal);
  const claimed = bnToNumber(data.scnStats.totalClaimed);
  const price = bnToNumber(data.scnPrice);

  const holdings = claimable + wallet;
  const portfolioUsd = holdings * price;
  // Total SCN earned from the platform = already claimed + still claimable.
  const totalEarned = claimed + claimable;

  const segments = [
    { label: "Claimable", value: claimable, color: "#2bf5a6" },
    { label: "In Wallet", value: wallet, color: "#2ee6ff" },
    { label: "Claimed", value: claimed, color: "#c84bff" },
  ];
  const total = claimable + wallet + claimed;

  return (
    <div className="stack">
      <div className="hero hero-anim">
        <div className="hero-label">SCN Portfolio Value</div>
        <div className="hero-value">
          $<CountUp value={portfolioUsd} decimals={2} />
        </div>
        <div className="muted mt-2" style={{ fontSize: 13 }}>
          {fmtScn(data.scnStats.claimable)} claimable · {fmtScn(data.scnBal)} in wallet
        </div>
      </div>

      {/* Total SCN earned */}
      <div className="grid grid-2">
        <div className="stat stat-accent">
          <div className="label">Total SCN Earned</div>
          <div className="value grad-text"><CountUp value={totalEarned} decimals={2} /></div>
        </div>
        <div className="stat stat-accent">
          <div className="label">SCN Price</div>
          <div className="value grad-text-cyan">$<CountUp value={price} decimals={2} /></div>
        </div>
      </div>

      <div className="card">
        <SectionHeader icon="coins" title="SCN Distribution" accent="success" />
        <div className="row" style={{ gap: 18, alignItems: "center" }}>
          <Donut segments={segments} centerTop={fmtScn(holdings, 2)} centerBottom="SCN held" />
          <div className="legend" style={{ flex: 1 }}>
            {segments.map((s) => (
              <div className="legend-item" key={s.label}>
                <span className="legend-dot" style={{ background: s.color }} />
                <span className="legend-label">{s.label}</span>
                <span className="legend-value">
                  {total > 0 ? Math.round((s.value / total) * 100) : 0}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ClaimSCN
        scnStats={data.scnStats}
        scnBal={data.scnBal}
        scnPrice={data.scnPrice}
        onDone={refresh}
      />
    </div>
  );
}
